import { bindToggle } from 'material-ui-popup-state/core';
import { bindPopover, usePopupState } from 'material-ui-popup-state/hooks';

import { EXTERNAL_LINKS } from '@cast/constants';
import {
  Icons,
  List,
  ListItem,
  ListItemText,
  Stack,
  Tooltip,
  tokens,
} from '@cast/design-system';
import { getDocsLink, isChatLoaded, openChat } from '@cast/utils';
import {
  useReopenOnboardingWizard,
  useShouldShowGettingStartedHelpEntry,
} from 'features/onboarding-wizard';

import { HeaderIconButton } from './HeaderIconButton';
import { HeaderPopover } from './HeaderPopover';

export const HelpMenu = () => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'help-menu',
  });
  const popoverState = bindPopover(popupState);
  const isPylonLoaded = isChatLoaded();
  const showGettingStarted = useShouldShowGettingStartedHelpEntry();
  const reopenGettingStarted = useReopenOnboardingWizard();

  return (
    <>
      <HeaderIconButton
        {...bindToggle(popupState)}
        active={popupState.isOpen}
        aria-label="Help & Resources"
        data-testid="help-menu-btn"
      >
        <Icons.Question
          size={20}
          color={tokens.theme.fg.structural.secondary}
        />
      </HeaderIconButton>

      <HeaderPopover {...popoverState} testId="help-menu">
        <List size="medium" disablePadding sx={{ minWidth: '190px' }}>
          {showGettingStarted ? (
            <ListItem
              testId="help-getting-started"
              onClick={() => {
                reopenGettingStarted();
                popupState.close();
              }}
            >
              <ListItemText>Getting started</ListItemText>
            </ListItem>
          ) : null}

          <ListItem
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component="a"
            testId="help-documentation-link"
            target="_blank"
            rel="noreferrer noopener"
            href={getDocsLink('docs')}
            onClick={() => popupState.close()}
          >
            <ListItemText>
              <Stack direction="row" alignItems="center" gap={4}>
                Documentation
                <Icons.ArrowSquareOut size="1.3em" />
              </Stack>
            </ListItemText>
          </ListItem>

          <ListItem
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component="a"
            testId="help-academy-link"
            target="_blank"
            rel="noreferrer noopener"
            href="/api/v1/auth/academy/sso"
            onClick={() => popupState.close()}
          >
            <ListItemText>
              <Stack direction="row" alignItems="center" gap={4}>
                Academy
                <Icons.ArrowSquareOut size="1.3em" />
              </Stack>
            </ListItemText>
          </ListItem>

          <ListItem
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component="a"
            testId="help-community-link"
            target="_blank"
            rel="noreferrer noopener"
            href={EXTERNAL_LINKS.castai_slack_community}
            onClick={() => popupState.close()}
          >
            <ListItemText>
              <Stack direction="row" alignItems="center" gap={4}>
                Community
                <Icons.ArrowSquareOut size="1.3em" />
              </Stack>
            </ListItemText>
          </ListItem>

          <ListItem
            testId="help-get-support-btn"
            onClick={() => {
              openChat();
              popoverState.onClose();
            }}
          >
            <Tooltip
              title={
                "Check your cookie settings if you don't see the chat bubble."
              }
              placement="right"
              wrapIf={!isPylonLoaded}
            >
              <ListItemText>Get support</ListItemText>
            </Tooltip>
          </ListItem>
        </List>
      </HeaderPopover>
    </>
  );
};
